/**
 * STRUTTURE DI DEFAULT CENTRALIZZATE PER I CATALOGHI
 * Questo file contiene le strutture di default che rispecchiano esattamente il formato del database
 * per garantire consistenza tra tutti i componenti
 */

import { primaryShades, backgroundTokens } from '../../theme/theme';

/**
 * Struttura di default per un catalogo che rispecchia il formato del database
 * Questa struttura deve essere usata sia per la creazione che per la modifica
 */
export const defaultCatalogueStructure = {
    // Campi base
    allowedDomain: null,
    appIdIos: "",
    appPackage: "",
    appPackageIos: "",
    codePath: "",
    coverImage: null,
    dataConsumption: "",
    draftCreatedAt: null,
    draftedCatalogRef: null,
    glassesNumber: null,
    hdrEnvironment: "",
    isDraft: false,
    isExpired: false,
    isIframeOnlyAcces: false,
    isLoginRequired: false,
    isPublic: true,
    isSegmentationOn: false,
    layout: "v1",
    lightIntensityExponent: 1.0,
    list_service: null,
    loginPassword: null,
    nameCatalog: "",
    noBackgroundLogo: "",
    originalCatalogueId: "",
    showSingleDotList: true,
    skin: null,
    storageConsumption: null,
    storage_consumption: {
        consumption: 0,
        modelsNumber: 0
    },
    takePicTemplate: "",
    urlLogo: "",
    webDomain: "",
    webUrl: "",

    // ✅ CAMPI SEO - STRUTTURA PIATTA DEL DATABASE
    titleSeo: "",
    featuredImage: null,
    list_keywords: [],
    descriptionIt: "",
    descriptionEn: "",
    descriptionFr: "",
    descriptionEs: "",
    descriptionDe: "",

    // ✅ STILE DELLA PAGINA DEL CATALOGO
    catalogues_page_style: {
        actionButtonColor: primaryShades.primary500,
        backgroundColor: backgroundTokens.surface,
        primaryColor: primaryShades.primary500,
        secondaryColor: primaryShades.primary300,
        bannerBackgroundColor: backgroundTokens.surface, // Bianco di default

        // Border radius per le card
        cardCornerTopLeft: 0,
        cardCornerTopRight: 0,
        cardCornerBottomRight: 0,
        cardCornerBottomLeft: 0,

        // Border radius per i button
        buttonCornerTopLeft: 0,
        buttonCornerTopRight: 0,
        buttonCornerBottomRight: 0,
        buttonCornerBottomLeft: 0,

        // Border radius per il banner
        bannerCornerTopLeft: 0,
        bannerCornerTopRight: 0,
        bannerCornerBottomRight: 0,
        bannerCornerBottomLeft: 0,

        // Logo e posizione
        catalogueLogo: "",
        catalogueLogoPosition: "center",
        isLogoVisible: true,
        isTitleVisible: true,

        // ✅ ALTEZZE BANNER - USA I NOMI CORRETTI DEL DATABASE
        coverHeightDesktop: 100,
        coverHeightMobile: 100,

        // Immagini banner
        coverImg: "",
        coverImgMobile: "",

        // Campi legacy/inutilizzati
        coverColor: null,
        coverTemplate: null
    }
};

/**
 * Struttura di default per il form (struttura nidificata per l'UI)
 * Questa viene convertita dalla struttura database usando il mapping centralizzato
 */
export const defaultFormStructure = {
    catalogueName: "",
    domain: "",

    // ✅ SEO - STRUTTURA NIDIFICATA PER IL FORM
    seo: {
        title: "",
        featuredImage: null,
        keywords: [],
        metaDescriptions: {
            it: "",
            en: "",
            fr: "",
            es: "",
            de: ""
        }
    },

    // ✅ PERSONALIZZAZIONE - STRUTTURA NIDIFICATA PER IL FORM
    customization: {
        primaryColor: primaryShades.primary500,
        secondaryColor: primaryShades.primary300,
        backgroundColor: backgroundTokens.surface,
        actionButtonColor: primaryShades.primary500,
        bannerBackgroundColor: backgroundTokens.surface, // Bianco di default

        // Border radius
        cardCornerTopLeft: 0,
        cardCornerTopRight: 0,
        cardCornerBottomRight: 0,
        cardCornerBottomLeft: 0,
        buttonCornerTopLeft: 0,
        buttonCornerTopRight: 0,
        buttonCornerBottomRight: 0,
        buttonCornerBottomLeft: 0,
        bannerCornerTopLeft: 0,
        bannerCornerTopRight: 0,
        bannerCornerBottomRight: 0,
        bannerCornerBottomLeft: 0
    },

    // ✅ BANNER - STRUTTURA NIDIFICATA PER IL FORM
    banner: {
        // ✅ USA I NOMI CORRETTI DEL DATABASE PER LE ALTEZZE
        coverHeightDesktop: 100,
        coverHeightMobile: 100,
        // ✅ CAMPI PER L'UI DEI RADIO BUTTON
        heightOption: "100",
        heightMobileOption: "100",
        // ✅ CAMPI DELL'INTERFACCIA ORIGINALE
        height: 100,
        heightMobile: 100,
        bannerImage: null,
        bannerImageMobile: null,
        logoPosition: "center",
        isLogoVisible: true,
        isTitleVisible: true,
        logo: null
    },

    // ✅ PERMESSI - STRUTTURA NIDIFICATA PER IL FORM
    permissions: {
        public: true,
        requireLogin: false,
        loginPassword: "",
        iframeOnlyAccess: false,
        allowedDomain: ""
    }
};

/**
 * Crea una copia deep della struttura di default del catalogo
 * @returns {Object} Copia della struttura di default
 */
export const createDefaultCatalogueStructure = () => {
    return JSON.parse(JSON.stringify(defaultCatalogueStructure));
};

/**
 * Crea una copia deep della struttura di default del form
 * @returns {Object} Copia della struttura di default del form
 */
export const createDefaultFormStructure = () => {
    return JSON.parse(JSON.stringify(defaultFormStructure));
}; 